/* eslint-disable no-mixed-spaces-and-tabs */
import Loader from '@/components/ui/Loader/Loader';
import nf from '@/constants/nf';
import { ExpandMore } from '@mui/icons-material';
import dayjs from 'dayjs';
import { Accordion, AccordionDetails, AccordionSummary, Pagination } from '@mui/material';
import { twMerge } from 'tailwind-merge';
import { format } from 'date-fns';

export default function NewTopUps({ isFetching, isFetched, topUpList, topUpCount, page, handleChangePagination }) {
	return (
		<div className='relative flex flex-col min-h-24'>
			{isFetching && <Loader />}
			{isFetched && topUpList?.length > 0 && (
				<div className='flex flex-col gap-4 mt-4'>
					{/* <span className='pl-4 font-bold'>Self Service Top Up</span> */}
					{topUpList.map((t) => {
						const tItems = t.topUps.map((to) => {
							return (
								<div key={to.id}>
									<table className='w-full table-fixed'>
										<tbody>
											<tr>
												<td className={twMerge('break-words pr-2 align-top w-[15%]')}>({to.id}) {to.requested_at ? format(new Date(to.requested_at), 'HH:mm') : ''}</td>
												<td className={twMerge('break-words pr-2 text-center align-top w-[35%]')}>{to.status.toUpperCase()}</td>
												<td className={twMerge('break-words pr-2 text-center align-top w-[23%]')}>{to.payment_type_name}</td>
												<td className={twMerge('break-words text-right align-top w-[27%]')}>{nf(Math.abs(+to.amount))}</td>
											</tr>
										</tbody>
									</table>
									{to.note && <span className='w-full pl-2 text-sm italic'>Reason: {to.note}</span>}
								</div>
							);
						});
						const date = dayjs(new Date(t.date)).format('dddd, DD MMMM YYYY');
						return (
							<Accordion key={t.date}>
								<AccordionSummary expandIcon={<ExpandMore />} aria-controls='panel1-content' id='panel1-header'>
									<span className='font-bold'>{date}</span>
								</AccordionSummary>
								<AccordionDetails>
									<div className='flex flex-col gap-2'>
										<div className='flex flex-col gap-1'>{tItems}</div>
									</div>
								</AccordionDetails>
							</Accordion>
						);
					})}
				</div>
			)}
			{isFetched && ((typeof orderList === 'object' && Object.keys(topUpList).length === 0) || topUpList?.length === 0) && (
				<span className='w-full text-center'>No top up found</span>
			)}
			{isFetched && <Pagination className='mt-4 ml-auto' count={topUpCount} page={page} onChange={handleChangePagination} />}
		</div>
	);
}
